import { FormType } from '../../../form-types';

export const antiAgingBeluga: FormType = {
  name: 'Anti-Aging Visit',
  olderVersions: ['antiAging'],
  questions: [
    {
      key: 'antiAgingBeluga_sexAssignedAtBirth',
      next: {
        condition: {
          'antiAgingBeluga_sexAssignedAtBirth.antiAgingBeluga_sexAssignedAtBirth_female':
            true
        },
        key: 'antiAgingBeluga_pregnancy',
        els: 'generic_heightWeight2025'
      }
    },
    {
      key: 'antiAgingBeluga_pregnancy',
      next: {
        condition: {
          'antiAgingBeluga_pregnancy.antiAgingBeluga_pregnancy_yes': true
        },
        key: 'antiAgingBeluga_ineligible',
        els: 'antiAgingBeluga_pregnancyConsent'
      }
    },
    {
      key: 'antiAgingBeluga_pregnancyConsent',
      next: {
        condition: {
          'antiAgingBeluga_pregnancyConsent.antiAgingBeluga_pregnancyConsent_disagree':
            true
        },
        key: 'antiAgingBeluga_didNotConsent',
        els: 'generic_heightWeight2025'
      }
    },
    'generic_heightWeight2025',
    'antiAgingBeluga_reason',
    {
      key: 'antiAgingBeluga_symptoms',
      next: {
        condition: {
          'antiAgingBeluga_symptoms.antiAgingBeluga_symptoms_other': true
        },
        key: 'antiAgingBeluga_symptoms_other_details',
        els: 'antiAgingBeluga_previousTreatment'
      }
    },
    'antiAgingBeluga_symptoms_other_details',
    {
      key: 'antiAgingBeluga_previousTreatment',
      next: {
        condition: {
          'antiAgingBeluga_previousTreatment.antiAgingBeluga_previousTreatment_yes':
            true
        },
        key: 'antiAgingBeluga_previousReactions',
        els: 'antiAgingBeluga_kidneyLiver'
      }
    },
    {
      key: 'antiAgingBeluga_previousReactions',
      next: {
        condition: {
          'antiAgingBeluga_previousReactions.antiAgingBeluga_previousReactions_yes':
            true
        },
        key: 'antiAgingBeluga_previousReactions_details',
        els: 'antiAgingBeluga_kidneyLiver'
      }
    },
    'antiAgingBeluga_previousReactions_details',
    'antiAgingBeluga_kidneyLiver',

    {
      key: 'antiAgingBeluga_cancerTreatment',
      next: {
        condition: {
          'antiAgingBeluga_cancerTreatment.antiAgingBeluga_cancerTreatment_yes':
            true
        },
        key: 'antiAgingBeluga_ineligible',
        els: 'antiAgingBeluga_otherInformation'
      }
    },
    'antiAgingBeluga_otherInformation',
    {
      key: 'antiAgingBeluga_treatmentConsent',
      next: {
        condition: {
          'antiAgingBeluga_treatmentConsent.antiAgingBeluga_treatmentConsent_disagree':
            true
        },
        key: 'antiAgingBeluga_didNotConsent',
        els: 'antiAgingBeluga_truthConsent'
      }
    },
    {
      key: 'antiAgingBeluga_truthConsent',
      next: {
        condition: {
          'antiAgingBeluga_truthConsent.antiAgingBeluga_truthConsent_disagree':
            true
        },
        key: 'antiAgingBeluga_didNotConsent',
        els: 'antiAgingBeluga_complete'
      }
    },
    'antiAgingBeluga_ineligible',
    'antiAgingBeluga_didNotConsent',
    'antiAgingBeluga_complete'
  ]
};
export const antiAging: FormType = {
  name: 'Anti-Aging',
  questions: [
    'pregnantFuture',
    'birthControl',
    'skinGoals',
    'skinSensitivity',
    'skinCarePrefrence',
    'skinProducts',
    'skinAcknowledgement'
  ]
};
